import $$ from 'cmn-utils'

const baseUrl = "/api/weather/"
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },

}